// extracted by mini-css-extract-plugin
export var emptyState = "_50-d";
export var statCard = "_50-c";
export var table = "_50-0";
export var tableCell = "_50-4";
export var tableCellClickable = "_50-5 _50-4";
export var tableCellDefault = "_50-6 _50-4";
export var tableCellEmpty = "_50-8";
export var tableCellWithValue = "_50-7";
export var tableContainer = "_50-e";
export var tableHeaderWeight = "_50-1";
export var tableHeaderZone = "_50-2";
export var tableRowHeader = "_50-3";
export var viewModeButton = "_50-9";
export var viewModeButtonActive = "_50-a _50-9";
export var viewModeButtonInactive = "_50-b _50-9";